export enum SubscriptionPlan {
    TNA_COMPLIANCE = 'TNACompliance',
    TNA_BUNDLE = 'TNABundle',
    TIER30_MONTHLY = 'TIER30_MONTHLY',
    PER_LOCATION15 = 'PER_LOCATION15',
    PER_LOCATION3999 = 'PER_LOCATION3999',
    PREMIUM = 'PREMIUM',
    STARTER = 'STARTER',
    LOC_MO_PREM_DEFAULT = 'LOC_MO_PREM_DEFAULT',
    LOC_MO_STAR_DEFAULT = 'LOC_MO_STAR_DEFAULT',
    LOC_YR_PREM_DEFAULT = 'LOC_YR_PREM_DEFAULT',
    LOC_YR_STAR_DEFAULT = 'LOC_YR_STAR_DEFAULT',
    LOC_YR_PREM_REFERRAL = 'LOC_YR_PREM_REFERRAL',
    LOC_MO_PREM_IHD = 'LOC_MO_PREM_IHD',
    LOC_MO_PREM_IHD_AUD = 'LOC_MO_PREM_IHD_AUD',
}
